import React, { useState } from 'react';
// react bootstrap
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ChooseListModal = (props) => {
  const [selectedValue, setSelectedValue] = useState('finished');
  const [isCurrentPageValid, setIsCurrentPageValid] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Choose List
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Row} className='mb-3 ms-3'>
          <Form.Label as='legend' column sm={2} style={{ fontWeight: 'bold' }}>
            Lists
          </Form.Label>
          <Col sm={10}>
            <Form.Check
              value='finished'
              type='radio'
              label='Finished'
              name='formHorizontalRadios'
              id='formHorizontalRadios1'
              onChange={(e) => setSelectedValue(e.target.value)}
              checked={selectedValue === 'finished'}
            />
            <Form.Check
              value='reading'
              type='radio'
              label='Reading'
              name='formHorizontalRadios'
              id='formHorizontalRadios2'
              onChange={(e) => setSelectedValue(e.target.value)}
              checked={selectedValue === 'reading'}
            />
            <Form.Check
              value='plan_to_read'
              type='radio'
              label='Plan To Read'
              name='formHorizontalRadios'
              id='formHorizontalRadios3'
              onChange={(e) => setSelectedValue(e.target.value)}
              checked={selectedValue === 'plan_to_read'}
            />
          </Col>
          {selectedValue === 'reading' && (
            <Form.Group className='my-3' controlId='formGroupCurrentPage'>
              <Form.Label style={{ fontWeight: 'bold' }}>
                Set Current Page
              </Form.Label>
              <Form.Control
                type='number'
                placeholder='0'
                max={props.book.totalPages}
                name='currentPage'
                value={currentPage}
                onChange={(e) => {
                  setCurrentPage(e.target.value);
                  setIsCurrentPageValid(true);
                }}
                isInvalid={!isCurrentPageValid}
              />
              {
                <Form.Control.Feedback type='invalid'>
                  Please enter a valid current page value !
                </Form.Control.Feedback>
              }
            </Form.Group>
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={props.onHide}>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={() => {
            // check current page validation if selectedValue = reading
            if (selectedValue === 'reading') {
              if (currentPage > props.book.totalPages || currentPage < 0) {
                setIsCurrentPageValid(false);
                return;
              }
              props.book.currentPage = currentPage;
            }
            props.addBookToList(props.book, selectedValue);
          }}
        >
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChooseListModal;
